<template>
  <div>
    <Dialog
      :visible.sync="mbpDepartmentsForm1"
      :style="{ width: '640px', overflowY: 'auto' }"
      header="MBP Department Details"
      :modal="true"
      class="p-fluid"
    >
      <div class="p-formgrid p-grid">
        <div class="p-field p-col">
          <label for="deptName">Name</label>
          <InputText
            id="deptName"
            v-model.trim="mbpDepartment.deptName"
            required="true"
            autofocus
            :class="{ 'p-invalid': submitted && !mbpDepartment.deptName }"
            :disabled="disabledArr.includes('deptName')"
          />
          <small class="p-invalid" v-if="submitted && !mbpDepartment.deptName"
            >Name is required.</small
          >
        </div>
      </div>
      <div class="p-formgrid p-grid">
        <div class="p-field p-col">
          <label for="deptCode">Code</label>
          <InputText
            id="deptCode"
            v-model.trim="mbpDepartment.deptCode"
            required="true"
            autofocus
            :class="{ 'p-invalid': submitted && !mbpDepartment.deptCode }"
            :disabled="disabledArr.includes('deptCode')"
          />
          <small class="p-invalid" v-if="submitted && !mbpDepartment.deptCode"
            >Code is required.</small
          >
        </div>
        <div class="p-field p-col">
          <label for="active">Mark Active</label>
          <SelectButton
            v-model="mbpDepartment.active"
            :options="options"
            optionLabel="name"
          />
        </div>
      </div>

      <template #footer>
        <Button
          label="Reset"
          icon="pi pi-refresh"
          class="p-button-text"
          @click="reset"
        />
        <ProgressSpinner
          v-if="sendingRequest"
          style="width:25px; height:25px; width: 100px;"
          strokeWidth="5"
          fill="#EEEEEE"
          animationDuration=".5s"
        />
        <Button
          v-else
          label="Save"
          icon="pi pi-check"
          class="p-button-text"
          @click="save"
        />
        <Button
          label="Cancel"
          icon="pi pi-times"
          class="p-button-text"
          @click="cancel"
        />
      </template>
    </Dialog>
  </div>
</template>

<script>
export default {
  props: [
    "mbpDepartmentToEdit",
    "mbpDepartmentForm",
    "sendingRequest",
    "disabledArr"
  ],
  data: () => ({
    mbpDepartment: {},
    submitted: false,
    options: [
      { name: "Active", value: true },
      { name: "Inactive", value: false }
    ]
  }),
  created() {
    if (this.mbpDepartmentToEdit && this.mbpDepartmentToEdit.id) {
      this.mbpDepartment = { ...this.mbpDepartmentToEdit };
      this.mbpDepartmentToEdit.active
        ? (this.mbpDepartment.active = { name: "Active", value: true })
        : (this.mbpDepartment.active = { name: "Inactive", value: false });
    }
  },
  computed: {
    mbpDepartmentsForm1: {
      set(val) {
        if (!val) {
          this.cancel();
        }
      },
      get() {
        return this.mbpDepartmentForm ? true : false;
      }
    }
  },
  watch: {
    mbpDepartmentForm(val) {},
    mbpDepartmentToEdit(val) {
      this.mbpDepartmentsForm1++;
    }
  },
  methods: {
    reset() {
      this.mbpDepartment = {};
    },
    save() {
      this.submitted = true;

      let obj = { ...this.mbpDepartment };

      if (obj.deptName) {
        if (obj.active instanceof Object) {
          obj.active = obj.active.value;
        }

        this.$emit("save", obj);
      }
    },
    cancel() {
      this.$emit("close");
    }
  }
};
</script>

<style></style>
